import { MouseEvent } from 'react'
import { reaction } from 'mobx'
import { message } from 'antd'
import { sha256 } from 'js-sha256'
import { DWBeijingTime, GetPreProcessHS, SemDownloadHS } from 'src/commons/store/BasisStore'
import { AppConfig, AppStore, GameLibraryStore } from 'src/pc/store/AppStore'
import {
  getUpgradeVipInfoHS,
  qualificationHS,
  UserInfoHS,
  activityUserQualificationHs,
  activityGiftsHttpHs,
  firstActivityGoodsListHS,
} from 'src/commons/store/UserStore'
import {
  getActivityConfigInfoHS,
  getAllActivityGoodsCouponHttp,
  getActivityGoodsCouponByIdsHttp,
} from 'src/commons/store/GameStore'
import { MtJsWebSDK } from '@mt0926/js-web-sdk'
import { useWaitModData } from '@hhpack/use-cms'
import { history } from 'src/commons/utils/WebCommons'
import {
  activityEntranceHS,
  DWGetActivityConfigInfo,
  activitySignUpHttp,
  activityReceiveHttp,
} from 'src/commons/store/GameStore'
import moment from 'moment'
import Cookies from 'js-cookie'
import md5 from 'js-md5'
import { isChangshaGJ } from 'src/commons/utils/Commons'

export const ACTIVE_12_NO = 'AT5550500854873092726'
export const ACTIVE_NEWYEAR_NO = 'AT5557838191672197583'

//export const PhonePattern = /^((13[0-9])|(14[5,7])|(15[0-3,5-9])|(17[0,3,5-8])|(18[0-9])|166|198|199|(147))\s?\d{4}\s?\d{4}\s?$/
export const CardIdPattern = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/

/* eslint-disable-next-line */
export const NamePattern = /^(([a-zA-Z+\.?\·?a-zA-Z+]{2,30}$)|([\u4e00-\u9fa5+\·?\u4e00-\u9fa5+]{2,30}$))/
export const PhonePattern = /^1\d{2}\s?\d{4}\s?\d{4}\s?$/
export const QQPattern = /^[1-9]\d{4,15}$/
export const PhoneOrQQPattern = /(^1\d{2}\s?\d{4}\s?\d{4}\s?)|(^[1-9]\d{4,11}$)/
export const PasswordPattern = /(?!^\d+$)(?!^[A-Za-z]+$)(?!^[^A-Za-z0-9]+$)(?!^.*[\u4E00-\u9FA5].*$)^\S{6,16}$/

/** sem特殊要求， 匹配到当前渠道不显示微信登录入口 */
// export const notViewWechatEntry = ['360gh09sh', '360th10', '360th09', '360ghsh10', '360lqgh', 'sggh09sh']

export function GUID(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export enum GameOrderType { //['', '购买游戏账号', '直充游戏', '购买可回收游戏', '游戏试玩']
  '购买游戏账号' = 1,
  '直充游戏' = 2,
  '购买试玩账号' = 3,
  '游戏试玩' = 4,
}

export enum GameOrderStatus { //['未支付', '支付成功', '购买成功', '处理中', '购买失败', '维权中', '退款成功', '退款失败']
  '未支付' = 0,
  '支付成功' = 1,
  '购买成功' = 2,
  '处理中' = 3,
  '购买失败' = 4,
  '维权中' = 5,
  '退款成功' = 6,
  '退款失败' = 7,
  '取消维权' = 8,
  '已结束' = 9,
  '退款中' = 10,
  '已取消' = 11,
}

export const OpenLink = (Link?: string, IsStop?: boolean, ClickEvent?: () => void) => {
  if (Link) {
    if (window.FuluApp) {
      return {
        onClick: (e?: MouseEvent) => {
          if (IsStop) {
            e?.stopPropagation()
          }
          window.FuluApp!.JSNotifyCppFunc('open_url', Link)
          ClickEvent?.()
        },
      }
    }
    return {
      href: Link,
      target: '_blank',
      onClick: (e?: MouseEvent) => {
        if (IsStop) {
          e?.stopPropagation()
        }
        ClickEvent?.()
      },
    }
  }
  return {}
}

export const FormatUserId = (UserId: number) => {
  return `U${UserId.toString(16)}`
}

/**
 * 折扣语义化
 * @param {Number} Discount 折扣
 */
export const discountSemantics = (Discount: number, noUnit?: boolean): string => {
  /*if (Discount * 100 < 10) {
    return '特惠'
  } else*/
  if (isNaN(Discount)) {
    return noUnit ? '10' : '10折'
  }

  if (Discount >= 1) {
    return noUnit ? '10' : '10折'
  }
  const Str = (Math.floor(Discount * 100) / 10).toFixed(1)
  return noUnit ? `${Str}` : `${Str}折`
}

export const filterDiscount = (num1: number, num2: number) => {
  const temp = Math.ceil((1 - num1 / num2) * 1000) / 10
  if (num2 < num1) {
    return `-0%`
  }
  if (temp === 100) {
    return `-99.9%`
  }
  return `-${temp}%`
}
/**
 * 随机生成手机号
 */
export const CratePhoneNum = () => {
  let PhoneHeader = `${Random(100, 999)}`
  while (!/^((13[0-9])|(14[5,7])|(15[0-3,5-9])|(17[0,3,5-8])|(18[0-9])|166|198|199|(147))$/.test(PhoneHeader)) {
    PhoneHeader = `${Random(100, 999)}`
  }
  return `${PhoneHeader}****${Random(1000, 9999)}`
}

/** 隐藏手机号中间四位 */
export const formatHideMobile = (mobile: string) => {
  return `${mobile.substr(0, 3)}****${mobile.substr(7, 11)}`
}

/**
 * 获取渠道
 */
export const GetChannel = () => {
  const recordUrl = localStorage.getItem('firstUrl')
  const finalLocation = recordUrl ? new URL(recordUrl) : window.location
  /*通过域名获取渠道*/
  let HostChannel = finalLocation.host.substr(0, finalLocation.host.indexOf('.'))
  //长沙管家域名规则 client-xx.steamvipmall.com
  if (isChangshaGJ) {
    HostChannel = HostChannel.replace('client-', '')
  }
  /*通过 URL 查询字段获取渠道*/
  const Query = new URLSearchParams(finalLocation.search.substr(1, finalLocation.search.length))
  return Query.get('channel') || HostChannel || 'simpleshq'
}

/**
 * 判断是否是抖音渠道包(为了避免首次打开出现延迟跳转列表页的问题，渠道写死)
 */
export const checkIsDouyinChannel = () => {
  const cmsConfig = AppStore.douyinChannelConfig || localStorage.getItem('douyinChannelConfig')?.split(',')
  const config = process.env.BUILD_TYPE === 'prod' ? ['ouyegame', 'dsdyzy01', 'csdy01'] : cmsConfig
  return config?.includes(GetChannel())
}

/*平台下载地址*/
export const PlatformDownloadUrl = {
  1: 'https://media.st.dl.bscstorage.net/client/installer/SteamSetup.exe',
  2: 'https://www.dm.origin.com/download',
  4: 'https://www.ubisoft.com.cn/clicks/12',
  5: 'https://launcher-public-service-prod06.ol.epicgames.com/launcher/api/installer/download/EpicGamesLauncherInstaller.msi',
  6: 'https://www.blizzard.com/zh-tw/download/confirmation?platform=windows&locale=zhTW&version=LIVE&id=bnetdesk',
}

export const CreateOnlineUser = () => {
  const currentDate = moment().hour()
  let base = 0
  if (currentDate >= 2 && currentDate <= 11) {
    base = 260772
  }
  if (currentDate >= 12 && currentDate <= 17) {
    base = 380696
  }
  if ((currentDate >= 18 && currentDate <= 24) || currentDate <= 2) {
    base = 571541
  }
  return Math.floor(
    base * (0.95 + Math.floor((Math.random() * ((1.27 - 0.95) * 100)) / 100)) - Math.floor(Math.random() * 2200),
  )
}

/*下载地址*/
export const downUrl = () => {
  return `http://download.99box.com/?f=${GetChannel() || 'steam9'}`
}

/*创建下载客户端 iframe*/
export const CreateDownloadIframe = (url: string, fileName: string) => {
  let iframe = document.getElementById('download') as HTMLIFrameElement | null
  if (iframe) {
    iframe.remove()
    iframe = null
  }
  iframe = document.createElement('iframe')
  iframe.src = `https://downloads.99box.com/index.html?url=${url}&fileName=${fileName}`
  iframe.id = 'download'
  iframe.style.display = 'none'
  document.body.appendChild(iframe)
  iframe = null
}

/*下载客户端*/
export const DownloadClient = (replaceFileName?: (fileName: string) => string) => {
  const PreProcessInfo = GetPreProcessHS.SuccessResult
  if (PreProcessInfo) {
    const fullPath = PreProcessInfo.location
      ? `${PreProcessInfo.location}?filename=${
        replaceFileName ? replaceFileName(PreProcessInfo.loadFileName) : PreProcessInfo.loadFileName
      }`
      : downUrl()
    const iframe: HTMLIFrameElement | null = document.createElement('iframe')
    iframe.src = fullPath
    iframe.style.position = 'absolute'
    iframe.style.top = '0'
    iframe.style.left = '0'
    iframe.style.zIndex = '-999'
    iframe.style.opacity = '0'
    document.body.appendChild(iframe)
    // /** 这里假如当前在商品详情页
    //  * 则详情页的地址为 /store/game/${gameLibraryId}/${gameId}
    //  * 通过split分割后， 第4个为gameId
    //  */
    // const refererGame =
    //   window.location.pathname.startsWith('/store/game/') || window.location.pathname.startsWith('/store/newGame/')
    //     ? window.location.pathname.split('/')[4] || ''
    //     : ''
    // SemDownloadHS.Execute({ id: `${PreProcessInfo.id}`, refererGame })
    //   .then(res => {
    //     if (res) {
    //       const url = new URL(res)
    //       if (replaceFileName) {
    //         CreateDownloadIframe(url.pathname, replaceFileName(PreProcessInfo.loadFileName))
    //       } else {
    //         CreateDownloadIframe(url.pathname, PreProcessInfo.loadFileName)
    //       }
    //     } else {
    //       window.open(downUrl())
    //     }
    //   })
    //   .catch(() => {
    //     window.open(downUrl())
    //   })
  }
}

/*工具类型*/
export const GameToolType = {
  1: '存档',
  2: 'MOD',
  3: '辅助',
}

/*获取文件哈希*/
export const SHA1File = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const fr = new FileReader()
    fr.onload = async ev => {
      const buffer: ArrayBuffer = ev.target?.result as ArrayBuffer
      resolve(
        hexString(await window.crypto.subtle.digest('SHA-1', buffer)) + file.name.substr(file.name.lastIndexOf('.')),
      )
    }
    fr.readAsArrayBuffer(file)
  })
}

/*获取字符串哈希*/
export const hexString = (buffer: ArrayBuffer) => {
  const byteArray = new Uint8Array(buffer)
  const hexCodes = [...byteArray].map(value => {
    const hexCode = value.toString(16)
    return hexCode.padStart(2, '0')
  })
  return hexCodes.join('')
}
export const CustomerIsOnline = (): boolean => {
  //2020-8-13 改为24小时在线
  return true

  // const Now = moment()
  // const TodayMM = Now.hour() * 60 + Now.minute() //今天过了多少分钟

  /*if ([1, 4].includes(Now.day())) {
    /!*周1/4： 9.30~00.00*!/
    return TodayMM > 9.5 * 60 && TodayMM < 24 * 60
  }
  if ([2, 3].includes(Now.day())) {
    /!*周2/3： 13.00~21.00*!/
    return TodayMM >= 13 * 60 && TodayMM <= 21 * 60
  }*/
  /*if ([2, 3].includes(Now.day())) {
    /!*周2/3： 13.00~21.00*!/
    return TodayMM >= 13 * 60 && TodayMM <= 21 * 60
  }*/
  /*if ([4, 5, 6].includes(Now.day())) {
    /!*周4/5/6 9:30 ~ 00:00*!/
    return TodayMM >= 9.5 * 60 && TodayMM <= 24 * 60
  }*/
  /*其它时间段 全天24小时*/
  // return TodayMM >= 10 * 60 && TodayMM <= 24 * 60
}

/*生成指定返回内的随机数*/
export const Random = (min: number, max: number) => {
  return parseInt(String(Math.random() * (max - min + 1) + min), 10)
}

/**
 * 比较两个版本大小
 * @param current 当前版本
 * @param ver 指定版本
 * @return boolean
 */
export const CompareVersion = (current: number[], ver: number[]) => {
  let VersionIsNew = false
  for (let i = 0; i < current.length; i += 1) {
    //当前版本大于指定版本
    if (current[i] > ver[i]) {
      VersionIsNew = true
      break
    } else if (current[i] < ver[i]) {
      VersionIsNew = false
      break
    }
  }
  return VersionIsNew
}
/**订单类型*/
export const OrderType: { [key in OrderType]: string } = {
  1: '独享',
  2: '直冲',
  3: '试玩账号',
  4: '试玩',
  6: '共享',
  7: '单机',
  8: '独享',
  9: '加速器',
  10: '升级独享',
  11: '集合包',
  12: 'CDK',
  13: '加速器',
  19: '换购卡',
  21: '会员',
  26: '换购',
  17: '礼包抽奖',
  18: 'VIP服务',
  23: '升级CDK',
  22: '代购',
  27: '开箱次数',
  31: '福袋集合包',
  32: '道具',
  34: '存档',
  37: '会员升级',
  38: '代充',
  39: '捆绑包',
  41: '加速器时长',
  42: '云游戏',
  43: '合约',
  47: '特价集合包',
  50: '汉化包',
  51: 'MOD',
  52: '自助充值',
  53: '会员捆绑包',
  130: '首充',
}

/** 第三方商品 */
export const thirdGoodsMap = {
  weBuff: '修改器',
  coldLightSpeed: '加速器',
  associateMember: '联合会员',
}

/** 支付成功页订单类型 */
export const orderTypeMap = {
  18: 'VIP客服',
  32: '饰品',
  34: '存档',
  42: '云游戏',
}

/**账号类型*/
export const AccountType: { [key: number]: string } = {
  6: '卡密',
  8: '直冲',
  9: 'CDK',
  37: '加速器',
}

/**
 * 两个float数相乘小数进度精度错误
 * @param arg1
 * @param arg2
 */
export const floatMul = (arg1: number, arg2: number) => {
  let m = 0
  const s1 = arg1.toString()
  const s2 = arg2.toString()
  try {
    m += s1.split('.')[1].length
  } catch (e) {
    console.log(e)
  }
  try {
    m += s2.split('.')[1].length
  } catch (e) {
    console.log(e)
  }
  return (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) / 10 ** m
}

export const isTimes = (curdate: number, startTime: string, endTime: string) => {
  const startdate = new Date(startTime)
  const enddate = new Date(endTime)
  const a = curdate - startdate.getTime() / 1000
  const b = curdate - enddate.getTime() / 1000

  if (a < 0 || b > 0) {
    return false
  } else {
    return true
  }
}

export const signatureEncode = (str: string) => {
  //算法: 先反序、再sha256、再反序、再md5
  const timeR = String(str).split('').reverse().join('')
  const timeSha256R = sha256(timeR).split('').reverse().join('')
  return md5(timeSha256R)
}

/** 判断富文本内容是否为空 */
export const htmlIsEmpty = (html: string) => {
  const finalHTML = html.replace(/<p>/g, '').replace(/<\/p>/g, '')
  return !finalHTML.trim()
}

/**
 * 最多保留N位小数
 * @param num
 * @param fractionDigits
 */
export const toFixed = (num: string | number, fractionDigits: number) => {
  const _num = String(num)
  if (!_num.includes('.') || isNaN(Number(num))) {
    return num
  }
  const arr = _num.split('.')
  arr[1] = arr[1].substr(0, fractionDigits)
  return arr.join('.')
}
/**
根据身份证号码判断性别
15位身份证号码：第7、8位为出生年份(两位数)，第9、10位为出生月份，第11、12位代表出生日
18位身份证号码：第7、8、9、10位为出生年份(四位数)，第11、第12位为出生月份，
第13、14位代表出生日期，第17位代表性别，奇数为男，偶数为女。
*/
//根据身份证号获取年龄
export const getAge = (identityCard: string): number => {
  const len = (identityCard + '').length
  let strBirthday = ''
  if (len === 18) {
    //处理18位的身份证号码从号码中得到生日和性别代码
    strBirthday = identityCard.substr(6, 4) + '/' + identityCard.substr(10, 2) + '/' + identityCard.substr(12, 2)
  }
  if (len === 15) {
    let birthdayValue = ''
    birthdayValue = identityCard.charAt(6) + identityCard.charAt(7)
    if (parseInt(birthdayValue) < 10) {
      strBirthday =
        '20' + identityCard.substr(6, 2) + '/' + identityCard.substr(8, 2) + '/' + identityCard.substr(10, 2)
    } else {
      strBirthday =
        '19' + identityCard.substr(6, 2) + '/' + identityCard.substr(8, 2) + '/' + identityCard.substr(10, 2)
    }
  }
  //时间字符串里，必须是“/”
  const birthDate = new Date(strBirthday)
  const nowDateTime = new Date()
  let age = nowDateTime.getFullYear() - birthDate.getFullYear()
  //再考虑月、天的因素;.getMonth()获取的是从0开始的，这里进行比较，不需要加1
  if (
    nowDateTime.getMonth() < birthDate.getMonth() ||
    (nowDateTime.getMonth() === birthDate.getMonth() && nowDateTime.getDate() < birthDate.getDate())
  ) {
    age--
  }
  return age
}

/** 小于1M, 转换成K, 大于1M，转成M  */
export const exchangeSize = (size: number) => {
  if (size === 0) {
    return `0B`
  } else if (size < 1024 * 1024) {
    // console.log(`${(size / 1024).toFixed(2)}KB`)
    return `${(size / 1024).toFixed(2)}KB`
  } else {
    // console.log(`${(size / 1024 / 1024).toFixed(2)}MB`)
    return `${(size / 1024 / 1024).toFixed(2)}MB`
  }
}

// 获取视频的封面
export const getVideoPoster = (width: number, height: number, videoUrl: string) => {
  return videoUrl + `?x-oss-process=video/snapshot,t_2000,f_jpg,w_${width},h_${height}`
}

/**
 *
 * @param arr  一维数组
 * @param n  设置几个为一行
 */
export const arrayToDim = (arr: Array<any>, n = 3) => {
  const newArray = []
  for (let i = 0; i < Math.ceil(arr.length / n); i++) {
    newArray[i] = arr.slice(i * n, (i + 1) * n)
  }
  return newArray
}

// 将时间转换成几天前，几个月前，几小时前等
export const getDateDiff = (dateTimeStamp: number) => {
  //dateTimeStamp是一个时间毫秒，注意时间戳是秒的形式，在这个毫秒的基础上除以1000，就是十位数的时间戳。13位数的都是时间毫秒。
  let result: string = ''
  const minute = 1000 * 60 //把分，时，天，周，半个月，一个月用毫秒表示
  const hour = minute * 60
  const day = hour * 24
  const week = day * 7
  const halfamonth = day * 15
  const month = day * 30
  const year = month * 12
  const now = new Date().getTime() //获取当前时间毫秒
  const diffValue = now - dateTimeStamp //时间差

  if (diffValue < 0) {
    return
  }
  const minC = diffValue / minute ////计算时间差的分，时，天，周，月
  const hourC = diffValue / hour
  const dayC = diffValue / day
  const yearC = diffValue / year
  const weekC = diffValue / week
  const monthC = diffValue / month
  if (yearC >= 1) {
    result = moment(dateTimeStamp).format('YY-MM-DD HH:mm:ss')
  } else if (dayC >= 1 && yearC <= 1) {
    result = moment(dateTimeStamp).format('MM-DD HH:mm:ss')
  } else if (hourC > 3 && hourC <= 24) {
    result = moment(dateTimeStamp).format('MM-DD HH:mm:ss')
  } else if (hourC >= 1 && hourC <= 3) {
    result = ' ' + Math.floor(hourC) + '小时前'
  } else if (minC > 30 && minC <= 59) {
    result = '1小时内'
  } else if (minC > 10 && minC <= 30) {
    result = '半小时内'
  } else if (minC >= 1 && minC <= 10) {
    result = '10分钟内'
  } else if (diffValue >= 0 && diffValue <= minute) {
    // && diffValue <= minute
    result = '刚刚'
  }
  return result
}
//列表格式化富文本显示
export const fiflterListRichText = (str: string) => {
  str = fiflterRichText(str)
  str = str.replace(/<.*?>/g, '')
  str = str.replace(/<\s?img[^>]*>/g, '')
  str = str.replace(/<\s?video[^>]*>/g, '')
  str = str.replace(/\n/g, '')
  str = str.replace(/\s/g, '')
  return str
}

//格式化富文本显示 换行问题
export const fiflterRichText = (str: string) => {
  str = str.replace(/<p><\/p><div class="media-wrap image-wrap"><\/div>/g, '')
  str = str.replace(/<p><\/p><div class="media-wrap video-wrap"><\/div>/g, '')
  str = str.replace(/(^(<br>)+)|((<br>)+$)/g, '')
  return str
}
//检测字符串中文
export function checkChinese(htmlStr: string) {
  const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g')
  return reg.test(htmlStr)
}

//格式化文本域显示,防止xss
export const fiflterTextAreaXss = (str: string) => {
  str = str.replace(/[<]|[>]/g, '')
  str = str.replace(/\n/g, '<br>')
  str = str.replace(/\s/g, '&nbsp;')
  return str
}

//提取html字符串中的文本
export const getSimpleText = (html: string) => {
  const re1 = new RegExp('<.+?>', 'g') //匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
  const msg = html.replace(re1, '') //执行替换成空字符
  return msg
}
export const clearSelections = () => {
  // 获取选中
  const selection = window.getSelection()
  // 清除选中
  selection?.removeAllRanges()
}

/** 获取剪切板内容 */
export const getClipboard = (timeout: number = 1000) => {
  return new Promise((resolve, reject) => {
    if (window.FuluApp) {
      const timer = setTimeout(() => {
        resolve(null)
      }, timeout)
      window.FuluApp.clipboardResolve = (content: string) => {
        if (timer) {
          clearTimeout(timer)
        }
        resolve(content)
      }
      window.FuluApp.JSNotifyCppFunc('get_clipboard')
    } else {
      reject('must be in the client')
    }
  })
}

/**
 * 解析key & 设置属性值
 * @param obj
 * @param keyStr eg：module_1_box_1_item_1_title
 * @param value  eg:'test'
 * eg: obj.module[0].box[0].item[0].title='text'
 */
export const setObjKeyValue = (obj: IKeyValue, keyStr: string, value: string) => {
  const t = keyStr.split('_')
  if (t.length === 1) {
    obj[t[0]] = value
  } else {
    const result: string[][] = []
    for (let i = 0; i < t.length; i += 2) {
      result.push(t.slice(i, i + 2))
    }
    result.reduce((previousValue, currentValue) => {
      const key = currentValue[0]
      const index = currentValue[1]
      const parent = previousValue
      if (isNaN(Number(index))) {
        if (!Array.isArray(parent) && typeof parent[key] === 'undefined') {
          parent[key] = value
        }
      } else {
        const temp = (parent[key] = parent[key] || [])
        const _index = Number(index) - 1
        return (temp[_index] = temp[_index] || {})
      }
      return parent[key]
    }, obj)
  }
}

//解析复杂的cms数据结构
export const parseComplexCmsData = <T = any>(source: { [key: string]: string }) => {
  const data = {}
  Object.keys(source).forEach(key => {
    setObjKeyValue(data, key, source[key])
  })
  return data as T
}

//数组分组
export const groupArray = (data: any[], n: number) => {
  return Array.from(Array(Math.ceil(data.length / n))).map((_, i) => data.slice(i * n, (i + 1) * n))
}

//去重
export const uniqueArray = (arr: any[]) => {
  return Array.from(new Set(arr))
}

/**
 * 生成随机字符串
 * @param range
 */
export const getRandomStr = (range: number) => {
  let returnStr = ''
  const charFun = function () {
    const n = Math.floor(Math.random() * 62)
    if (n < 10) {
      return n //1-10
    } else if (n < 36) {
      return String.fromCharCode(n + 55) //A-Z
    } else {
      return String.fromCharCode(n + 61) //a-z
    }
  }
  while (returnStr.length < range) {
    returnStr += charFun()
  }
  return returnStr
}

//获取范围内的随机数
export const getRandom = (minNum: number, maxNum: number) => {
  return parseInt(String(Math.random() * (maxNum - minNum + 1) + minNum), 10)
}

//获取随机头像
export const getRandomAvatar = (num: number) => {
  const typeList = [
    { name: 'man', max: 20 },
    { name: 'woman', max: 20 },
    { name: 'animal', max: 20 },
    { name: 'interest', max: 15 },
  ]
  return Array(num)
    .fill('')
    .map(value => {
      const type = typeList[getRandom(0, 3)]
      const num = getRandom(1, type.max)
      return `https://steam-api.dadagame.com/avatar/${type.name}/${num}.png`
    })
}

export enum CommonPromiseKeyMapping {
  REAL_NAME_AUTH = 'REAL_NAME_AUTH',
  START_TIPS = 'START_TIPS',
  GAME_HELP = 'GAME_HELP',
  SPEED = 'SPEED',
}

const commonPromiseStore: Partial<Record<CommonPromiseKeyMapping, TCommonPromise>> = {}

export const getCommonPromise = (key: CommonPromiseKeyMapping): TCommonPromise => {
  if (!commonPromiseStore[key]) {
    commonPromiseStore[key] = {
      resolve: () => {},
      reject: () => {},
    }
  }
  return commonPromiseStore[key]!
}

/**
 * 检测进程是否存在（是否在运行）
 * @param processName
 * @param processUniqueName
 */
export const getProcessStatus = (processName: string, processUniqueName?: string) => {
  const isSupportCheckSpeedStatus =
    !!AppConfig.Version &&
    CompareVersion(
      AppConfig.Version.split('.').map(d => Number(d)),
      [2, 0, 0, 2288],
    )
  if (!isSupportCheckSpeedStatus) {
    console.log('不支持状态检测')
    return Promise.resolve(0)
  }
  AppStore.processStatus = null
  console.time('get_process_status')
  const check = new Promise(resolve => {
    const disposer = reaction(
      () => AppStore.processStatus,
      status => {
        console.timeEnd('get_process_status')
        resolve(status)
        disposer && disposer()
      },
    )
    window.FuluApp?.JSNotifyCppFunc('get_process_status', processName, processUniqueName)
  })
  const checkTimeout = new Promise(resolve => {
    setTimeout(() => {
      resolve(0)
    }, 2000)
  })
  return Promise.race([check, checkTimeout])
}

export const countDownSendLiveBroadcastNum = () => {
  clearTimeout(AppStore.bulletCountdownTimer)
  if (AppStore.bulletCountdown === 0) {
    AppStore.bulletSendLoading = false
    AppStore.bulletCountdown = 60
  } else {
    Object.assign(AppStore, {
      bulletSendLoading: true,
      bulletCountdown: AppStore.bulletCountdown - 1,
    })
    AppStore.bulletCountdownTimer = window.setTimeout(() => {
      countDownSendLiveBroadcastNum()
    }, 1000)
  }
}

/**
 * 向主窗口发送消息
 * @param type 消息标识
 * @param data 相关数据
 */
export const sendMessageToMainClient = (type: string, data?: { [p: string]: any }) => {
  window.FuluApp?.JSNotifyCppFunc(
    'speed2client_msg',
    JSON.stringify({
      __type__: type,
      ...(data ?? {}),
    }),
  )
}

/**
 * 向加速球发送消息
 * @param type 消息标识
 * @param data 相关数据
 */
export const sendMessageToSpeedBall = (type: string, data?: { [p: string]: any }) => {
  window.FuluApp?.JSNotifyCppFunc(
    'client2speed_msg',
    JSON.stringify({
      __type__: type,
      ...(data ?? {}),
    }),
  )
}

/**
 * 处理渠道分组数据，用于首页推荐、集合包模块
 */
export const handleChannelGroupData = (data: any[] | undefined, idsPrefix: string, channelGroup: string = '') => {
  if (!data) {
    return []
  }
  const formatFullIdsField = channelGroup ? `${idsPrefix}_${channelGroup}` : idsPrefix
  return data.map(value => {
    return {
      ...value,
      ids: value[formatFullIdsField] || value[idsPrefix],
    }
  })
}

/**
 * 获取已安装的本地游戏
 */
let getInstalledGameListTimeout: NodeJS.Timeout
export const getInstalledGameList = (isFlush: 0 | 1 = 0) => {
  if (!window.FuluApp || AppStore.getInstalledGameLoading) {
    console.log('getInstalledGameLoading, please wait')
    return
  }
  setTimeout(() => {
    window.FuluApp?.JSNotifyCppFunc('get_install_game_list', isFlush)
  }, 0)
  AppStore.getInstalledGameLoading = true
  getInstalledGameListTimeout && clearTimeout(getInstalledGameListTimeout)
  getInstalledGameListTimeout = setTimeout(() => {
    AppStore.getInstalledGameLoading = false
  }, 60 * 1000)
}

/**
 * 格式化数字
 * @param n 要格式化的数字
 * @param fractionDigits 保留的小数位
 */
export const toFixedOrInt = (n: string | number, fractionDigits: number = 2) => {
  const num = Number(n)
  return (!isNaN(num) && Number(num.toFixed(fractionDigits))) || 0
}

export const VIP_GOODS_INFO = 'VIP_GOODS_INFO'

/**
 * 服务器时间，粗略校准
 */
export class BeijingTime {
  static offset = 0

  static async init() {
    try {
      const { time } = await DWBeijingTime.Execute()
      //记录偏移
      BeijingTime.offset = time * 1000 - Date.now()
    } catch (e) {
      console.log('BeijingTime init err', e)
    }
  }

  static now() {
    //1s内的偏移，以客户端为准
    return Date.now() + (Math.abs(BeijingTime.offset) > 1000 ? BeijingTime.offset : 0)
  }

  /** 距离今天结束剩余时间  单位ms */
  static diffToDay() {
    const now = this.now()
    const date = new Date(now)
    date.setHours(23)
    date.setMinutes(59)
    date.setSeconds(59)
    date.setMilliseconds(99)
    const today = date.getTime()
    return today - now
  }
}

export const LOGIN_INFO = 'LOGIN_INFO'

/**
 * 记录登录、注册信息
 * @param loginType 1密码 2验证码 3微信 4mac
 * @param isNew
 */
export const recordLoginInfo = (loginType: number, isNew: number) => {
  Cookies.set(LOGIN_INFO, `${loginType}-${isNew}`, {
    domain: process.env.BUILD_TYPE.startsWith('dev') ? 'localhost' : '99box.com',
    expires: new Date('2099/12/31 23:59:59'),
  })
}

const getLoginInfo = () => {
  const string = Cookies.get(LOGIN_INFO) ?? ''
  const [loginType, isNew] = string.split('-')
  return { loginType: loginType ? Number(loginType) : 0, isNew: isNew ? Number(isNew) : 0 }
}

/** 上报神策登录/注册 */
export const reportLogin = () => {
  const { loginType, isNew } = getLoginInfo()
  const OTHER = 'other'
  const map = ['', OTHER, 'number', 'wechat', OTHER]
  const typeText = map[loginType] ?? ''
  if (isNew) {
    console.log('reportLogin Clint_Register', typeText)
    window.sensorsdataReportParams?.('Clint_Register', {
      registerType: typeText,
    })
    try {
      MtJsWebSDK.track('client_register', {
        register_type: typeText,
      })
    } catch (error) {}
    //注册上报一次后，下次上报登录
    recordLoginInfo(loginType, 0)
    return
  }
  console.log('reportLogin Clint_Logon', typeText)
  window.sensorsdataReportParams?.('Clint_Logon', {
    logonType: typeText,
  })
  try {
    MtJsWebSDK.track('client_logon', {
      logon_type: typeText,
    })
  } catch (error) {}
}

//升级永久会员活动编号
export const UPGRADE_VIP_ACTIVITY_NO = 'AT5707425007205299414'

//获取用户升级永久会员活动信息
export const queryUpgradeVipInfo = async () => {
  //获取升级vip活动配置
  getUpgradeVipConfig()
  //获取用户活动信息
  const res = await getUpgradeVipInfoHS.Execute({ activityNo: UPGRADE_VIP_ACTIVITY_NO, channel: GetChannel() })
  console.log('queryUpgradeVipInfo', res)
  return res
}

//获取升级永久会员活动配置
export const getUpgradeVipConfig = async () => {
  const cfg = await getActivityConfigInfoHS.Execute({ activityNo: UPGRADE_VIP_ACTIVITY_NO })
  console.log('cfg', cfg)
  AppStore.upgradeVipConfig = cfg
}

/** 五一活动编号 */
export const LABOR_DAY_ACTIVITY_NO = 'AT5732785764617692982'

/** 获取五一会员活动信息 */
export const queryLaborDayVipInfo = async () => {
  getLaborDayVipConfig()
  const res = await qualificationHS.Execute({ activityNo: LABOR_DAY_ACTIVITY_NO, channel: GetChannel() })
  return res
}

/** 获取五一会员活动配置 */
export const getLaborDayVipConfig = async () => {
  const cfg = await getActivityConfigInfoHS.Execute({ activityNo: LABOR_DAY_ACTIVITY_NO })
  AppStore.laborDayActivity = cfg
  return cfg
}

/** 红包活动配置 */
export const RED_ENVELOPES_ACTIVITY_NO = 'AT5731439054763041953'

const getLocalStoreDataByUserId = (key: string): any[] | null => {
  const userInfo = UserInfoHS.SuccessResult
  if (!userInfo?.id) {
    return null
  }
  const datastr = localStorage.getItem(key)
  if (datastr && userInfo?.id) {
    return JSON.parse(datastr)[userInfo.id]
  }
  return null
}
/** 检测用户是否拥有配置的免费游戏 */
const checkUserHaveGame = async () => {
  try {
    const simpleshqPageGameConfig = await useWaitModData<TPageGame>('simpleshq_pagegame_config')
    if (!simpleshqPageGameConfig) {
      return false
    }
    const userInfo = UserInfoHS.SuccessResult
    if (!userInfo?.id) {
      return null
    }
    const removePageGameIds = getLocalStoreDataByUserId('removePageGameIds')
    console.log(removePageGameIds, 'removePageGameIds')
    const temp = removePageGameIds
      ? simpleshqPageGameConfig
        .filter(f => !removePageGameIds.includes(f.key))
          ?.find(d => d.key === AppStore.redEnvelopesActivityConfig?.activityConfig.gameId)
      : simpleshqPageGameConfig
    return !!temp
  } catch (error) {
    return false
  }
}

export const loadRedEnvelopesEntry = async () => {
  try {
    const Query = new URLSearchParams(window.location.search.substr(1, window.location.search.length))
    const deviceUid = Query.get('mid') || localStorage.getItem('mid') || ''
    const { claimEntry, signUpEntry, claimed, signUp, hasLottery } = await activityEntranceHS.Execute({
      activityNo: RED_ENVELOPES_ACTIVITY_NO,
      deviceId: deviceUid,
    })
    const haveGame = await checkUserHaveGame()
    console.log(`是否拥有该免费游戏: ${haveGame}`)
    if (!haveGame) {
      AppStore.redEnvelopesStatus.showClaimEntry = false
      AppStore.redEnvelopesStatus.showSignUpEntry = false
      AppStore.redEnvelopesStatus.hasLottery = false
      return
    }
    loadRedEnvelopesConfig()
    AppStore.redEnvelopesStatus.showClaimEntry = claimEntry
    AppStore.redEnvelopesStatus.showSignUpEntry = signUpEntry
    AppStore.redEnvelopesStatus.isClaimed = claimed
    AppStore.redEnvelopesStatus.isSignUp = signUp
    AppStore.redEnvelopesStatus.hasLottery = hasLottery
  } catch (error) {
    AppStore.redEnvelopesStatus.showClaimEntry = false
    AppStore.redEnvelopesStatus.showSignUpEntry = false
    AppStore.redEnvelopesStatus.hasLottery = false
    console.warn((error as any).message)
  }
}

/** 获取活动配置 */
export const loadRedEnvelopesConfig = async () => {
  const cfg = await DWGetActivityConfigInfo.Execute({ activityNo: RED_ENVELOPES_ACTIVITY_NO })
  AppStore.redEnvelopesActivityConfig = cfg
  return cfg
}

/** 领取红包 */
export const activityReceive = async (gameNo: string, game: string, callBack?: Function) => {
  try {
    if (AppStore.redEnvelopesStatus.isClaimed) {
      callBack?.()
      return
    }
    const Query = new URLSearchParams(window.location.search.substr(1, window.location.search.length))
    const deviceUid = Query.get('mid') || localStorage.getItem('mid') || ''
    const { amount } = await activityReceiveHttp.Execute({
      activityNo: RED_ENVELOPES_ACTIVITY_NO,
      gameNo,
      game,
      deviceId: deviceUid,
    })
    AppStore.redEnvelopesStatus.receivedAmount = amount
    loadRedEnvelopesEntry()
    callBack?.()
  } catch (error) {
    // const messageErr = (error as any).message
    // messageErr && message.warning(messageErr)
    loadRedEnvelopesEntry()
  }
}

/** 点击红包入口，领红包并且打开领取成功弹窗/打开参与活动弹窗 */
export const clickEntryEvent = (position: 'top' | 'Rightside') => {
  window.sensorsdataReportParams?.('RedEnvelope_Entry_Click', { position: position })
  if (!AppStore.redEnvelopesActivityConfig) {
    return
  }
  if (AppStore.redEnvelopesStatus.showClaimEntry) {
    activityReceive(
      AppStore.redEnvelopesActivityConfig?.activityConfig.gameId,
      AppStore.redEnvelopesActivityConfig?.activityConfig.gameName,
      () => (AppStore.redEnvelopesModal = true),
    )
    return
  }
  if (AppStore.redEnvelopesStatus.showSignUpEntry) {
    AppStore.redEnvelopesActivityModal = true
    return
  }
  if (AppStore.redEnvelopesStatus.isClaimed) {
    GameLibraryStore.currentPageGameKey = AppStore.redEnvelopesActivityConfig?.activityConfig.gameId || ''
    history.push('/my-game')
  }
}

export const COUPON_TEMPLATE_ACTIVITYNO = 'AT5741942240331427888'
/** 根据活动编号获取所有的商品优惠券配置 */
export const loadActivityCouponByNo = async (activityNo: string) => {
  try {
    const res = await getAllActivityGoodsCouponHttp.Execute({ activityNo })
    AppStore.activityGoodsCoupons[activityNo] = res
  } catch (error) {
    AppStore.activityGoodsCoupons[activityNo] = undefined
  }
}

/** 根据活动编号和商品ID获取商品优惠券配置 */
export const loadActivityCouponByIds = async (activityNo: string, goodsIds: string, gameLibraryId: string) => {
  if (!goodsIds || !gameLibraryId) {
    return
  }
  try {
    const res = await getActivityGoodsCouponByIdsHttp.Execute({ activityNo, goodsIds })
    AppStore.activityGoodsCouponsByGoodsId[gameLibraryId] = res
  } catch (error) {
    AppStore.activityGoodsCouponsByGoodsId[gameLibraryId] = undefined
  }
}

export const FOREVER_VIP_ACTIVITY_NO = 'AT5761047739379335900'

/**
 * 获取永久会员活动配置
 */
export const getForeverVipConfig = async () => {
  try {
    const cfg = await getActivityConfigInfoHS.Execute({ activityNo: FOREVER_VIP_ACTIVITY_NO })
    if (cfg.activityState === 1) {
      AppStore.foreverVipConfig = cfg
      return
    }
    AppStore.foreverVipConfig = null
  } catch (error) {
    AppStore.foreverVipConfig = null
  }
}

export const FIRST_PURCHARSE_GIFT_NO = 'AT5764013702131373001'
/** 获取首购活动资格、活动商品列表、活动赠品列表 */
export const getFirstPurchaseGiftConfig = async () => {
  try {
    activityUserQualificationHs.Execute({ activityNo: FIRST_PURCHARSE_GIFT_NO })
    activityGiftsHttpHs.Execute({ activityNo: FIRST_PURCHARSE_GIFT_NO })
    firstActivityGoodsListHS.Execute({ activityNo: FIRST_PURCHARSE_GIFT_NO })
  } catch (error) {
    message.error(error.message)
  }
}

export const NEWCOMER_WELFARE_NO = 'AT5553844368444957006'
/** 获取活动配置 */
export const getNewcomerWelfareConfig = async () => {
  const cfg = await getActivityConfigInfoHS.Execute({ activityNo: NEWCOMER_WELFARE_NO })
  AppStore.activityConfigWithNo[NEWCOMER_WELFARE_NO] = cfg
  return cfg
}
